export const GENERAL_MODULE_NAME = 'task';

export enum ActivityType {
	Task = 1266,
	CallIn = 1267,
	CallOut = 1268,
	Appointment = 1269,
	Sms = 1270,
	Survey = 1271,
	Email = 1272,
	Note = 1291,
	Form = 1294,
	Assessment = 1295,
}
